<template>
  <section class="no-results-wrapper">
    <i class="icon-no-result md" />
    <p>
      {{translate('offDealsNoMatchingResultsFilter')}}, <br />
       {{translate('offDealsChangeParameters')}}
    </p>
    <ClearAllFiltersBtn
      data-testid="button-clear-filters-no-filtered-results"
      @click="$emit('clearFilters')"
    />
  </section>
</template>

<script>
import ClearAllFiltersBtn from '@/components/filters/ClearAllFiltersBtn'
export default {
  name: 'NoFiltersResult',
  emits: ['clearFilters'],
  components: {
    ClearAllFiltersBtn
  }

}
</script>

<style scoped lang="scss">
.no-results-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 40px;

  i.icon-no-result {
    color: color('grey-cool');
  }

  p {
    margin-bottom: 0;
  }

  button.btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: color('primary');
    // font-weight: 600
  }
}
</style>
